// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"_2lirUy3","horizontalWrapper":"_2antc-u","articles":"_1iTI_UG","title":"_33M7R3J","articleTitle":"_1M7_I8_"};